import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  button {
    cursor: pointer;
  }
`

export default GlobalStyle
